import React, { useContext } from 'react'
import { Content, WrapTranscription } from './Style'
import { Record } from 'components'
import { Page } from 'pages'
import { Header, Phonemes } from '.'
import { TranscriptionContext } from './TranscriptionContext'
import { wordsRQ, transcriptionRQ } from 'store/hooks'
import { CustomSection, WrapAll } from 'styles/GlobalStyle'
import { NestedWordVM, WordVM } from 'models/VM'
import { useSelector } from 'react-redux'
import { getNestedWordsFetch } from 'store/middlewares/words.crud'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'

const Transcription = () => {
    const {
        letterAddOns,
        setLetterDescriptions, setWords, setLetterAddOns, setVowelCodes
    } = useContext(TranscriptionContext)
    const params = useParams()

    const { isCloseSttoper } = useSelector(state => state.markingWords)
    const { assessment } = useSelector(state => state.assessment)

    let assessmentID = assessment?.id
    if (!assessmentID)
        assessmentID = params.assessmentID

    const words = useQuery({
        queryKey: [qc.nestedWords, assessmentID],
        queryFn: async ({ signal }) => {
            const { data } = await getNestedWordsFetch({ id: assessmentID, signal, })
            const words = []
            data.words.forEach(word => words.push(new NestedWordVM(word)))
            setWords(words)
        },
        refetchOnWindowFocus: false,
    })

    const { } = transcriptionRQ.useGetLetterAddOns({
        onSuccess: ({ data }) => {
            setLetterAddOns(data)
        }
    })
    const { } = transcriptionRQ.useGetVowelCodes({
        onSuccess: ({ data }) => {
            setVowelCodes(data)
        }
    })
    const { } = transcriptionRQ.useGetLetterDescriptions({
        onSuccess: ({ data }) => {
            setLetterDescriptions(data)
        }
    })

    const disabledContent = isCloseSttoper

    return (
        <Page>
            <WrapAll>
                <Content>
                    <CustomSection height={210} $bg align="center">
                        <Record id="transcription" changeSetting showTimeline />
                    </CustomSection>
                    <Header disabledContent={disabledContent} />
                    <WrapTranscription $disabled={disabledContent} >
                        <Phonemes />
                    </WrapTranscription>
                </Content>
            </WrapAll>
        </Page>
    )
}

export default Transcription